<div class="bar" [class.full-width]="type === 'full'">
  <div class="fill" [style.width]="currentProgress"></div>
</div>
@if (!!type && type !== 'full') {
  <div class="description">{{currentProgress}}</div>
}
